import { api } from '@/store/api'
import type { TranslateArticleRequest, JobCreatedResponse, JobResponse } from './types'

export const aiApi = api.injectEndpoints({
  endpoints: (build) => ({
    translateArticle: build.mutation<
      JobCreatedResponse,
      { articleId: number; body: TranslateArticleRequest }
    >({
      query: ({ articleId, body }) => ({
        url: `ai/articles/${articleId}/translate`,
        method: 'POST',
        body,
      }),
    }),
    getAiJob: build.query<JobResponse, number>({
      query: (jobId) => `ai/jobs/${jobId}`,
    }),
  }),
})

export const { useTranslateArticleMutation, useLazyGetAiJobQuery } = aiApi
